export const green = '#BED000';
export const darkGreenColor = '#9db11f';
export const mediumGrey = '#B1B1B1';
export const polygonsShowOptions = {color: darkGreenColor, opacity: 1, fillOpacity: 0.2};
export const polygonsShowLiteOptions = {color: darkGreenColor, opacity: 0.7, fillOpacity: 0.1};
export const polygonsBorderingOptions = {color: mediumGrey, opacity: 0.5, fillOpacity: 0.05};
